import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconComponent implements OnInit {
    @Input() symbol: string;
    @Input() cssClass: string;
    @Input() height: string;
    @Input() width: string;
    svg: string;

    ngOnInit() {
        this.svg = `/assets/icons/${this.symbol}.svg`;
    }
}
